import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { Checkbox, IconButton, List, ListItem, ListItemText, Menu, Tooltip } from '@material-ui/core';
import TableEditIcon from 'mdi-react/TableEditIcon';
import cloneDeep from 'lodash/cloneDeep';

var GridToolbarColumns =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridToolbarColumns, _React$Component);

  function GridToolbarColumns() {
    var _this;

    _classCallCheck(this, GridToolbarColumns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GridToolbarColumns).apply(this, arguments));
    _this.state = {
      open: null
    };

    _this.openMenu = function (event) {
      _this.setState({
        open: event.currentTarget
      });
    };

    _this.closeMenu = function () {
      _this.setState({
        open: null
      });
    };

    _this.toggleColumn = function (field, value) {
      return function () {
        var _this$props = _this.props,
            columns = _this$props.columns,
            onChangeColumns = _this$props.onChangeColumns;
        var cloneColumns = cloneDeep(columns);
        cloneColumns.map(function (column) {
          if (field === column.field) {
            column.hide = value;
          }

          return column;
        });
        onChangeColumns(cloneColumns);
      };
    };

    return _this;
  }

  _createClass(GridToolbarColumns, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          columns = _this$props2.columns;
      var open = this.state.open;
      var columnsShow = columns.filter(function (column) {
        return !column.hide;
      }).length;
      return React.createElement(React.Fragment, null, React.createElement(Tooltip, {
        title: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0441\u0442\u043E\u043B\u0431\u0446\u043E\u0432",
        disableFocusListener: true,
        disableTouchListener: true
      }, React.createElement(IconButton, {
        className: classes.toolbarActionButton,
        color: 'inherit',
        size: 'small',
        onClick: this.openMenu
      }, React.createElement(TableEditIcon, {
        size: 20
      }))), React.createElement(Menu, {
        anchorEl: open,
        open: Boolean(open),
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        onClose: this.closeMenu
      }, React.createElement("div", {
        className: classes.toolbarMenu
      }, React.createElement("div", {
        className: classes.toolbarMenuHead
      }, "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0441\u0442\u043E\u043B\u0431\u0446\u043E\u0432"), React.createElement(List, null, columns.map(function (column, index) {
        return React.createElement(ListItem, {
          key: "column-".concat(index),
          dense: true,
          button: true,
          disabled: columnsShow === 1 && !column.hide,
          onClick: _this2.toggleColumn(column.field, !column.hide)
        }, React.createElement(Checkbox, {
          className: classes.toolbarMenuCheckbox,
          color: 'primary',
          checked: !column.hide,
          tabIndex: -1,
          disableRipple: true,
          value: '1',
          disabled: columnsShow === 1 && !column.hide
        }), React.createElement(ListItemText, {
          primary: column.label
        }));
      })))));
    }
  }]);

  return GridToolbarColumns;
}(React.Component);

export default GridToolbarColumns;